import React, { useEffect, useState } from "react";
// import ImageAbout from "../../../assets/images/about.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import API_URL from "../../../config/constant";

export default function About() {
    const { t } = useTranslation();
    const [aboutData, setAboutData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                // eslint-disable-next-line no-undef
                const response = await fetch(`${API_URL}/home?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const data = await response.json();
                if (data.about === null) {
                    throw new Error("Data not found");
                }
                setAboutData(data.about);
            } catch (error) {
                setAboutData(t("home.about", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);
    return (
        <>
            {/* WILL BE ENABLED SOON */}
            {/* <div className="bg-registerHere min-h-96 bg-no-repeat bg-cover bg-center h-full font-poppins flex justify-center items-center">
                <div className="text-center bg-[#164481] shadow-md cursor-pointer hover:shadow-2xl duration-300">
                    <p className="text-6xl xl:text-7xl 2xl:text-8xl text-white px-8 py-2">REGISTER HERE</p>
                </div>
            </div> */}
            <div className="bg-aboutMobile md:bg-about bg-no-repeat bg-cover bg-bottom relative font-poppins min-h-screen flex items-center">
                <div className="container grid grid-cols-1 md:grid-cols-2 text-white flex-wrap justify-center mx-auto">
                    <div className="w-full text-center flex flex-col max-md:pt-8">
                        <p className="text-3xl px-8 py-2 font-poppins font-bold text-white relative right-24 leading-[0.8]" style={{ letterSpacing: '4px' }}>{aboutData?.title}</p>
                        <p className="text-7xl md:text-8xl px-8 py-2 font-superWonder font-bold text-brandYellow leading-[0.8]" style={{ letterSpacing: '4px' }}>{aboutData?.subTitle}</p>
                        <p className="text-xl px-3 py-1 font-poppins font-black bg-white rounded-lg text-brandBlue w-fit relative left-[13rem] md:left-[22rem]" style={{ letterSpacing: '4px' }}>{aboutData?.caption}</p>
                    </div>
                    <div className="place-content-center w-full pt-10 pb-24 py-6 uppercase space-y-2 basis-full flex justify-center">
                        <div className="space-y-4 normal-case font-poppins font-medium max-w-[75vw] lg:max-w-[50vw] text-center md:text-left text-sm 2xl:text-base">
                            <div
                                className="space-y-4"
                                dangerouslySetInnerHTML={{ __html: aboutData?.content }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
